module.exports = __webpack_public_path__ + "Rutan-Light.svg";